import styled from 'styled-components';

export const Wrapper = styled.div`
	padding: 4px 4px 8px;
	width: 100%;
`;

export const Subtitle = styled.div`
	font-size: 16px;
	font-weight: 600;
	margin-bottom: 6px;
	color: ${({ theme }) => theme.colors.text.subtitle};
`;

export const List = styled.ul`
	list-style: disc;
	margin-bottom: 6px;
	color: ${({ theme }) => theme.colors.text.subtitle};
`;

export const Item = styled.li`
	font-size: 16px;
	font-weight: 400;
	list-style: disc;
	margin-left: 15px;

	span {
		color: ${({ theme }) => theme.colors.text.title};
	}
`;

export const ItemDown = styled.div`
	font-size: 16px;
	font-weight: 400;
`;

export const Actions = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;
`;
